import React, { Component } from 'react';
import { Popover, Row, Button, Menu, Modal } from 'antd';
import { withDomains, RESTExecutor } from '../lib/domain';
import { Link } from 'react-router-dom';
import { showErrorInNotification } from '../lib/util';
import { PersonOutline } from '@material-ui/icons';
import { COLORS } from '../pages/theme';

const { confirm } = Modal;

// for profile menu
class ProfilePage extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       visible:false,
       modal_visible:false,
       confirmLoading:false
    };

    this.logout_user=RESTExecutor.post().config({
      label:'logout'
    }).callbacks((success)=>{
      this.setState({
        modal_visible:false,
        confirmLoading:false
      })
        try{
          props.authenticator.initializer()
        }catch(e){
        }
    },(error)=>{
      showErrorInNotification(error)
    }).connect(props.domains.profile);
  };
  
  hide = () => {
    this.setState({visible: false});
};

handleVisibleChange = visible => {
    this.setState({visible});
};

handleOk = () => {
  this.setState({
    confirmLoading: true,
  });
  this.logout_user.execute();

 
};
handleLogout=()=>{
  let ctx=this;
  confirm({
    centered:true,
    okButtonProps:{
      loading:ctx.state.confirmLoading
    },
    title: 'Are you sure you want to logout of the system?',
    // content: 'When clicked the OK button, this dialog will be closed after 1 second',
    onOk() {
      ctx.handleOk()
      // return new Promise((resolve, reject) => {
      //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
      // }).catch(() => console.log('Oops errors!'));
    },
    onCancel() {},
  });
}

  render() {
    const {visible,modal_visible,confirmLoading}=this.state;
    const {authenticator}=this.props;
    let meta = authenticator.getTokens().meta || {};
    let user = meta.user_data || {};

    return (<React.Fragment>
          <Modal
          title="Are you sure you want to logout of the system?"
          centered
          
          visible={modal_visible}
          onOk={this.handleOk}
          confirmLoading={confirmLoading}
          onCancel={()=>{
            this.setState({modal_visible:false})
          }}
        ></Modal>
      <Popover
                className="hand-cursor"
                content={ <Menu
                defaultSelectedKeys={[]}
                selectedKeys={[]}
                >
                  
                   <Menu.Item key='change-password'  >
                   <Link to='/change-password' onClick={(t)=>{
                     this.setState({visible:false})
                   }}>
                  Change Password
                  </Link>
                  </Menu.Item>
                  
                  <Menu.Item key="logout" onClick={()=>{
                    // console.log(this.props)
                    // this.setState({modal_visible:true})
                    this.handleLogout();
                    // authenticator.initializer()
                  }}>
                  Logout
                  </Menu.Item>

                </Menu>}
                // overlayClassName="customNotification"
                title={user.username}
                trigger="click"
                placement='bottomLeft'
                visible={this.state.visible}
                onVisibleChange={this.handleVisibleChange}>

                    <PersonOutline
                        titleAccess="Profile"
                        style={{
                        fontSize: 24,
                        margin: 0,
                        marginLeft:20,
                        color:this.state.visible?COLORS.primary:COLORS.secondary
                    }}
                    type="user"/>
                    {/* <span style={{
                      opacity:this.state.visible?1:0.5,
                      color:'black',
                      marginLeft:6
                    }}>
                      {user.name}
                      <Icon type="down"  style={{marginLeft:6,fontSize:12}} />

                    </span> */}
            </Popover>
            </React.Fragment>
    );
  }
}

export default withDomains(ProfilePage,"adminAuth","profile");
